import { useCompetitionRegistrationCategorySummaryQuery } from '~/pages/competition/set-category/queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { useParams } from '~/hooks/useParams';
import { HasStyle } from '~/types/HasStyle';
import { idParamSchema } from '~/schemas';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & HasStyle;

function RegisterLifterCompetitionTypeSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { id } = useParams(idParamSchema.parse);

  const { data: competitionCategories } = useCompetitionRegistrationCategorySummaryQuery(id);

  const options = competitionCategories?.map(
    c => [c.competition_type.description, c.competition_type.id] as [string, number]
  );

  return (
    <Input.Select
      disabled={!options}
      placeholder="Välj tävlingstyp"
      name="competition_type"
      options={options ?? []}
      ref={ref}
      {...props}
    />
  );
}

export const RegisterLifterCompetitionTypeSelect = forwardRef(RegisterLifterCompetitionTypeSelectElement) as <
  TFormState extends BaseFormState,
>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof RegisterLifterCompetitionTypeSelectElement>;
